// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.input-container {
  /* make footer same height as dense toolbar */
  min-height: 48px;
  position: fixed;
  bottom: 0;
  bottom: env(safe-area-inset-bottom);
  left: 0;
  left: env(safe-area-inset-left);
  right: 0;
  right: env(safe-area-inset-right);
  background-color: white;
  border-top: 1px solid rgba(52, 152, 219, 0.1);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: 1000;
}
.toolbar-content {
  padding: 10px 16px;
  font-size: 16px !important;
  background: white !important;
  box-shadow: none !important;
  border-radius: 0;
  display: flex;
  align-items: center;
}
.v-input {
  margin-bottom: 0;
  font-family: 'Roboto', sans-serif;
  flex: 1;
}
.v-field__input:disabled {
  background-color: #f5f5f5 !important;
  color: #9e9e9e !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}
.toolbar-text {
  font-size: 1rem;
  padding: 0 12px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.input-button {
  margin-left: 8px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative;
  overflow: hidden;
  position: relative;
  z-index: 3;
}
.input-visible {
  display: flex !important;
}
.concierge-input {
  width: 100%;
}
.send-button {
  background: linear-gradient(135deg, #3498db, #2980b9) !important;
  color: white !important;
}
.send-button:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
  background: linear-gradient(135deg, #2980b9, #1c638e) !important;
}
.mic-button, .upload-button, .clear-button {
  color: #5f6368 !important;
  background: linear-gradient(135deg, #f8f9fa, #f1f3f4) !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}
.mic-button:hover, .upload-button:hover, .clear-button:hover {
  transform: translateY(-2px) scale(1.05);
  background: linear-gradient(135deg, #f1f3f4, #e8eaed) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}
.icon-color {
  color: inherit;
}
.v-icon {
  font-size: 20px !important;
  transition: all 0.3s ease;
}
.recorder-status {
  display: none;
  position: absolute;
  width: 100%;
  left: 0;
  padding: 0 16px;
}
.recorder-status.active {
  display: flex;
  z-index: 2;
}

/* Fix for progress linear components */
.v-progress-linear__indeterminate .long, 
.v-progress-linear__indeterminate .short {
  animation-play-state: running;
  left: auto;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
